import { useState, useEffect } from 'react';

import { CompleteFormData } from 'components/DynamicFormGroup/types/formTypes';
import { apiForms } from 'services/apiService';

export const useFetchFormsByGroup = (group_id: string, user_id: string) => {
  const [formData, setFormData] = useState<CompleteFormData[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFormsByGroup = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiForms.get(
          `/v1/forms/group/${group_id}/complete?user_id=${user_id}`
        );
        const data: CompleteFormData[] = response.data;
        setFormData(data);
      } catch (err: any) {
        setError(err.message || 'Error fetching form data');
        console.error('Error fetching forms by group:', err);
      } finally {
        setLoading(false);
      }
    };

    if (group_id && user_id) {
      fetchFormsByGroup();
    }
  }, [group_id, user_id]);

  return { formData, loading, error };
};

// Keep the old name for backward compatibility
export const useFetchCompleteForm = useFetchFormsByGroup;
